enum LogLevel {
  DEBUG,
  INFO,
  WARNING,
  ERROR,
}

export default LogLevel;
